<script>
    import { copyToClipboard } from "@/utils";
    import TheSvgIcon from "@main/packages/TheSvgIcon";
    import BaseTooltip from "@main/packages/BaseTooltip";
    import PromocodeColors from "@xd/components/PromocodeColors";

    export default {
        name: "PromocodeListItem",
        components: { TheSvgIcon, BaseTooltip, PromocodeColors },
        props: {
            promocode: Object,
            activeKey: Number,
        },
        computed: {
            isCopied() {
                return this.activeKey === this.$vnode.key;
            },
            textTooltip() {
                return this.isCopied ? "Уже скопировано" : "Нажми, чтобы скопировать";
            },
            colorText() {
                return this.promocode.text ? this.promocode.text : "на все цвета";
            },
        },
        methods: {
            onCopyPromocode() {
                copyToClipboard(this.promocode.code).then(() => {
                    this.$emit("set-active-key", this.$vnode.key);
                });
            },
        },
    };
</script>

<template>
    <div class="promocode-list-item">
        <router-link
            :to="{ name: 'Product', params: { slug: promocode.slug } }"
            class="promocode-list-item__title"
        >
            <span v-html="promocode.title"></span>
            <the-svg-icon name="arrow" :size-w="12"></the-svg-icon>
        </router-link>

        <div class="promocode-list-item__colors">
            <promocode-colors
                :colors="promocode.color"
                :text="promocode.text"
            ></promocode-colors>
        </div>

        <div v-if="promocode.isNew" class="promocode-list-item__label">Новинка</div>

        <div
            class="promocode-list-item__code"
            :class="{ 'is-active': isCopied }"
            @click="onCopyPromocode"
        >
            {{ promocode.code }}
            <div class="promocode-list-item__icon">
                <the-svg-icon name="copy" is-common :size-w="18"></the-svg-icon>
                <base-tooltip class="promocode-list-item__tooltip">
                    {{ textTooltip }}
                </base-tooltip>
            </div>
        </div>

        <img
            class="promocode-list-item__products"
            :src="`/static/xd-design/promocode/products/${promocode.image}.jpg?v=02022024`"
            alt=""
        />
    </div>
</template>

<style lang="scss">
    .promocode-list-item {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        height: 186px;
        margin-bottom: 15px;
        padding: 12px;
        background-color: #fff;
        border: 1px solid #fff;
        transition: 0.2s ease-in all;
        @include bp($bp-tablet-md) {
            width: calc(100% / 2 - 20px);
            height: 230px;
            margin: 0 10px 20px;
            padding: 16px;
        }
        @include bp($bp-desktop-sm) {
            width: calc(100% / 3 - 20px);
        }

        &:before {
            content: "";
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            border-radius: 10px;
            box-shadow: 0 0 50px #f2f2f5;
        }

        &:after {
            content: "";
            position: absolute;
            top: -1px;
            left: -1px;
            right: -1px;
            bottom: -1px;
            transition: 0.3s ease-in-out box-shadow;
        }

        &:hover {
            border-color: var(--primary);
            transform: translate(-4px, -4px);

            &:after {
                box-shadow: 4px 4px 0 var(--primary);
            }

            .promocode-list-item__products {
                transform: scale(1);
            }
        }
    }

    .promocode-list-item__title {
        position: relative;
        z-index: 5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        color: var(--primary-text);
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        transition: 0.3s ease-in-out color;
        @include bp($bp-tablet-md) {
            font-size: 18px;
        }

        &:hover {
            color: var(--secondary--light);
            text-decoration: underline;
        }

        svg {
            position: relative;
            top: 0;
            right: 0;
            transform: rotate(180deg);
            fill: var(--primary--dark);
        }
    }

    .promocode-list-item__label {
        margin-top: 8px;
        padding: 2px 6px;
        color: #fff;
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        background-color: #f50067;
        @include bp($bp-desktop-sm) {
            margin-top: 16px;
            padding: 4px 8px;
            font-size: 14px;
            line-height: 16px;
        }
    }

    .promocode-list-item__code {
        position: relative;
        z-index: 5;
        display: flex;
        align-items: center;
        margin-top: auto;
        margin-bottom: 8px;
        color: var(--secondary--light);
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        transition: 0.3s ease-in-out all;
        cursor: pointer;
        &.is-active {
            color: var(--success);
        }
        @include bp($bp-desktop-sm) {
            &:hover {
                .base-tooltip {
                    display: block;
                }
            }
        }
    }

    .promocode-list-item__icon {
        position: relative;
        margin-left: 2px;
        svg {
            transform: rotate(-90deg);
        }
    }

    .promocode-list-item__tooltip {
        text-transform: none;
    }

    .promocode-list-item__products {
        position: absolute;
        z-index: 0;
        right: 0;
        bottom: 0;
        max-width: 176px;
        border-radius: 15px;
        transition: 0.3s ease-in-out transform;
        transform: scale(0.98);
        @include bp($bp-tablet-md) {
            max-width: 224px;
        }
    }

    .promocode-list-item__colors {
        position: relative;
        z-index: 2;
    }
</style>
